import { isRequiredFieldTrueInObject } from 'utils/validators';
import moment from 'moment';

const validate = values => {
  const errors = {};

  if (values.daysArray && values.daysArray.length) {
    const daysArrayErrors = [];

    values.daysArray.forEach((day, dayIndex) => {
      const daysErrors = {};

      if (day.startTimeAndDuration && day.startTimeAndDuration.length) {
        const timeArrayErrors = [];

        const startTimeAndDurationFormatted = day.startTimeAndDuration.map(
          item => ({
            ...item,
            startTime: moment(item.startTime).format('HH:mm')
          })
        );

        startTimeAndDurationFormatted.map((item, itemIndex) => {
          const timeErrors = {};

          if (item.startTime && item.startTime === 'Invalid date') {
            timeErrors.startTime = 'Invalid time format';
            timeArrayErrors[itemIndex] = timeErrors;
          }
        });

        day.startTimeAndDuration.forEach((time, timeIndex) => {
          const timeErrors = {};

          if (isRequiredFieldTrueInObject(time.startTime || '', true)) {
            timeErrors.startTime = 'Time is required';
            timeArrayErrors[timeIndex] = timeErrors;
          }
        });

        if (timeArrayErrors.length || timeArrayErrors['_error']) {
          daysErrors.startTimeAndDuration = timeArrayErrors;
          daysArrayErrors[dayIndex] = daysErrors;
        }
      }
    });

    if (daysArrayErrors.length) {
      errors.daysArray = daysArrayErrors;
      errors.daysArray = { ...daysArrayErrors, _error: { ...daysArrayErrors } };
    }
  }

  return errors;
};

export default validate;
